import { EarningsPeriod } from '@api/api/earnings';
import { isBefore, subMonths } from 'date-fns';

export const getReportingPeriodLabel = ({
  fiscal_period,
  fiscal_year,
}: Pick<EarningsPeriod, 'fiscal_period' | 'fiscal_year'>) =>
  `${fiscal_period} ${fiscal_year}`;

/**
 * `reportingPeriods` is sorted from soonest/most-recent to oldest, so the
 * first item is the upcoming (or just-passed) report. Defaults to that
 * period once its reporting date is a month or less away, otherwise falls
 * back to the most recently reported quarter.
 */
export const getDefaultActiveReportingPeriod = (
  reportingPeriods: EarningsPeriod[]
): EarningsPeriod => {
  const [nextReportingPeriod] = reportingPeriods;

  const isWithinAMonthOfNextReport =
    !!nextReportingPeriod &&
    isBefore(
      subMonths(new Date(nextReportingPeriod.reporting_date), 1),
      new Date()
    );

  if (isWithinAMonthOfNextReport) {
    return nextReportingPeriod;
  }

  const lastReportedPeriod = reportingPeriods.find(period => period.reported);

  return lastReportedPeriod ?? nextReportingPeriod;
};
